const containerClassName = "flex flex-col items-center justify-center px-2 py-1 w-fit bg-white rounded-lg shadow-sm";
const textClassName = "text-xs text-center text-gray-500";
const valueClassName = "text-lg font-bold";

export const TotalFields = ({ totalData, itemName }) => (
  <div className="flex flex-row flex-wrap mt-4 gap-4">
    <div className={containerClassName}>
      <span className={textClassName}>{itemName}</span>
      <span className={valueClassName}>{totalData?.total ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Notifications</span>
      <span className={valueClassName}>{totalData?.notifications ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Questions</span>
      <span className={valueClassName}>{totalData?.questions ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Referrals</span>
      <span className={valueClassName}>{totalData?.referrals ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Canceled</span>
      <span className={valueClassName}>{totalData?.canceledClicks ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Clicks To Pay</span>
      <span className={valueClassName}>{totalData?.clicksToPay ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Digital Clicks</span>
      <span className={valueClassName}>{totalData?.softClicks ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Physical Clicks</span>
      <span className={valueClassName}>{totalData?.hardClicks ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Link Clicks</span>
      <span className={valueClassName}>{totalData?.linkClicks ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Total Clicks</span>
      <span className={valueClassName}>{totalData?.totalClicks ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Digital Buttons</span>
      <span className={valueClassName}>{totalData?.softButtons ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Physical Buttons</span>
      <span className={valueClassName}>{totalData?.hardButtons ?? "-"}</span>
    </div>
    <div className={containerClassName}>
      <span className={textClassName}>Total Buttons</span>
      <span className={valueClassName}>{totalData?.totalButtons ?? "-"}</span>
    </div>
  </div>
);